export default {
    WAREHOUSE_REGIONAL_LIST_VIEW: 'szp_warehouse_regional_list_view',
    WAREHOUSE_SUPPORTING_LIST_VIEW: 'szp_warehouse_supporting_list_view',
    FAMILY_EDITION_LIST_VIEW: 'szp_family_edition_list_view',
    ASSIGNED_FAMILY_EDITION_LIST_VIEW: 'szp_assigned_family_edition_list_view',
    FAMILY_LIST_VIEW: 'szp_family_list_view',
    FAMILY_TO_ACCEPT: 'szp_family_to_accept',
    VOLUNTEER_ASSIGN: 'szp_volunteer_assign',
    FAMILY_EDITION_ADD: 'szp_family_edition_add',
    FAMILY_EDITION_VIEW: 'szp_family_edition_view',
    ASSIGNED_FAMILY_EDITION_VIEW: 'szp_assigned_family_edition_view',
    FAMILY_EDITION_INCLUDE: 'szp_family_edition_include',
    FAMILY_EDITION_EXCLUDE: 'szp_family_edition_exclude',
    ASSIGNED_FAMILY_EDITION_EXCLUDE: 'szp_assigned_family_edition_exclude',
    FAMILY_EDITION_CHANGE_WIO_STRUCT: 'szp_family_edition_change_wio_struct',
    USE_SEARCH_ENGINE: 'szp_use_search_engine',
    SHOW_FAMILY_EDITIONS_WITHOUT_WIO_STRUCT: 'szp_show_family_editions_without_wio_struct',
    APPLICATION_ACCESS: 'szp_application_access',
    ADD_REGIONAL_WAREHOUSE: 'szp_warehouse_regional_add',
    ADD_SUPPORTING_WAREHOUSE: 'szp_warehouse_supporting_add',
    WAREHOUSE_REJON_CHECK: 'szp_warehouse_regional_check',
    WAREHOUSE_SUPPORTING_CHECK: 'szp_warehouse_supporting_check',
    FAMILY_EDITION_EDIT: 'szp_family_edition_update',
    SHEET_CORRECTING: 'szp_sheet_correcting',
    SHEET_PUBLISH: 'szp_sheet_publish',
    REVOKE_FAMILY_PUBLICATION: 'szp_revoke_publication',
    GIFTGIVER_EDIT_GIFT_GIVING_REPORT: 'szp_gift_giving_report_edit',
    GIFTGIVER_REMOVE: 'szp_giftgiver_remove',
    GIFTGIVER_ASSIGN: 'szp_giftgiver_assign',
    GIFTGIVER_EDIT: 'szp_giftgiver_edit',
    RESEND_MAIL: 'szp_giftgiver_resend_notification',
    RESEND_GIFT_GIVING_REPORT_NOTIFICATION: 'szp_giftgiver_resend_report_notification',
    SHEET_CORRECTING_AREA: 'szp_sheet_correcting_area',
    SHEET_CORRECTING_NATIONAL: 'szp_sheet_correcting_national',
    SHEET_EDIT: 'szp_sheet_edit',
    GIFT_GIVING_REPORT_CORRECTING_AREA: 'szp_gift_giving_report_correcting_area',
    GIFT_GIVING_REPORT_CORRECTING_NATIONAL: 'szp_gift_giving_report_correcting_national',
    FAMILY_TO_ACCEPT_INTERNAL: 'szp_family_to_accept_internal',
    FAMILY_TO_ACCEPT_EXTERNAL: 'szp_family_to_accept_external',
    FAMILY_CONSENT_EDIT: 'szp_consent_edit',
    FAMILY_CONSENT_EDIT_PRIVILEGED: 'szp_consent_edit_privileged',
    MANAGE_SWR: 'szp_family_choice_path_import_csv',
    SPECIALIST_PACKAGE_CREATE: 'szp_specialist_package_create',
    PRIVILEGED_FAMILY_EDITION_EDIT: 'szp_family_edition_update_privileged',
    FURTHER_STORY_PERMISSION: 'szp_family_edition_further_story',
    FAMILY_CHOICE_PATH_LINK_VIEW: 'szp_family_choice_path_link_view'
};
